<!-- <p *ngIf="fetchingResults" style="text-align:center">
<mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
</p> -->

@if (!fetchingResults) {
  <div class="car-box-list">
    @if (carBriefs == undefined || carBriefs.length === 0) {
      <h6>Aucun véhicule trouvé </h6>
    }
    @for (carBrief of carBriefs ; track carBrief; let i = $index) {
      <app-car-box
        [businessLine]= businessLine!
        [carBrief]="carBrief"
        [isSeller]="((currentUserId$ | async)! === carBrief.sellerId)"
        [carImage]="(carImageSamples$ | async)!.get(carBrief.imagesFilenames![0])!">
      </app-car-box>
    }
  </div>
  } <!-- [carImage]="carImageSamples!.get(carBrief.id)!"
  [isSeller]="((currentUserId$ | async)! === carBrief.sellerId)" -->

